import { Text } from '@vinted/web-ui'

import Block from '../Block'

type Props = {
  heading: string
  blocks: Array<ComponentProps<typeof Block>>
}

const Content = ({ heading, blocks }: Props) => {
  return (
    <>
      <div className="content-block__heading u-ui-padding-vertical-x2-large@desktops u-ui-padding-top-large@portables u-ui-padding-bottom-x-large@portables">
        <Text as="span" html>
          <span className="c-text--responsive-small-heading">{heading}</span>
        </Text>
      </div>
      <div className="content-block__blocks">
        <div className="row">
          {blocks.map(({ title, body, imageSrc }, index) => (
            <Block key={index} title={title} body={body} imageSrc={imageSrc} />
          ))}
        </div>
      </div>
    </>
  )
}

export default Content
